import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Header from "../../Header";
import Footer from "../../../Footer";
import { ReactComponent as Spinner } from "../../../assets/images/spinner.svg";
import TestView from "../../../components/TestView";
import StepProgress from "../../../components/StepProgress";
import PaymentForm from "../../../components/PaymentForm";
import ExpertValidation from "../../../components/ExpertValidation";
import "../styles.css";

export default function DesktopThankyou({ head, subhead, state }) {
  const { t, i18n } = useTranslation();
  const [status, setStatus] = useState("loading");
  const [currentStep, setCurrentStep] = useState(3);
  const [clientSecret, setClientSecret] = useState("");
  const [amount, setAmount] = useState({});
  const [user, setUser] = useState({});
  const [prescription, setPrescription] = useState({});
  
  const initialSteps = [
    { id: 1, label: t("Prescription Uploaded"), completed: true },
    { id: 2, label: t("Exam Completed"), completed: true },
    { id: 3, label: t("Payment"), completed: false },
    { id: 4, label: t("Expert Validation"), completed: false },
    { id: 5, label: t("Results"), completed: false },
  ];
  
  const [steps, setSteps] = useState(initialSteps);

  const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Criar ou obter um PaymentIntent do servidor
  const fetchPaymentIntent = async () => {
    const token = new URLSearchParams(window.location.search).get("token");
    try {
      await delay(2000);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/user/create-payment-intent`,
        { lng: i18n.language, token },
        { withCredentials: true }
      );
      setClientSecret(data.clientSecret);
      setAmount({ amount: data.amount, currency: data.currency });
      setUser({ name: data.user.name, email: data.user.email, mobileNumber: data.user.mobileNumber, lastName: data.user.lastName });
      setPrescription(data.prescription);
      // Update the steps
      (data.step === 5) ? setCurrentStep(6) : setCurrentStep(data.step);
      const updatedSteps = [...steps];
      
      // Mark all steps before the current step as completed
      updatedSteps.forEach((step, index) => {
        if (step.id < data.step) {
          updatedSteps[index].completed = true;
        }
        if (data.step === 5) updatedSteps[updatedSteps.length - 1].completed = true;
      });
      
      setSteps(updatedSteps);

      if (data.step === 4) {
        setStatus("expert-validation");
      } else if (data.step === 5) {
          setStatus("prescription");
      } else {
        setStatus("payment");
      }
    } catch (error) {
      console.error("Erro ao criar payment intent:", error);
      // Usar demostração como fallback
      setClientSecret("");
    }
  };

  useEffect(() => {      
    // fetchPaymentIntent();
  }, []);

  if (status === "loading") {
    return (
      <>
        <main className="loading">
          <Spinner />
        </main>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="thank-you-page">
        <div className="thank-you-container">
          <StepProgress steps={steps} currentStep={currentStep} />
          
          {status === "payment" && <PaymentForm
            clientSecret={clientSecret}
            amount={amount}
            user={user}
            setCurrentStep={setCurrentStep}
            setStatus={setStatus}
            steps={steps}
            setSteps={setSteps}
          />}
          {status === "expert-validation" && <ExpertValidation />}
          {status === "prescription" && <TestView data={prescription} />}
        </div>
      </div>
      <Footer />
    </>
  );
}
